import Card from "./Card";
import type { SectionItem } from "@/api";

interface ListProps {
  items: SectionItem[];
  onItemClick?: (item: SectionItem) => void;
}

export default function List({ items, onItemClick }: ListProps) {
  return (
    <div className="px-4 pb-8">
      {items.map((item) => {
        const clickHandler = onItemClick ? () => onItemClick(item) : undefined;
        return (
          <Card
            key={item.id}
            title={item.title}
            subtitle={item.subtitle}
            imageUrl={item.image}
            date={item.date}
            {...(clickHandler !== undefined ? { onClick: clickHandler } : {})}
          />
        );
      })}
    </div>
  );
}
